export default [
    {
        path: 'vacina',
        component: () => import(/* wecadastrockChunkName: 'cadastro-vacina' */ '@/views/cadastro/vacina/Index'),
        redirect: 'vacina/index',
        children: [
            {
                name: 'cadastro-vacina-index',
                path: 'index',
                component: () => import(/* wecadastrockChunkName: 'cadastro-vacina' */ '@/views/cadastro/vacina/List.vue'),
            },
            {
                name: 'cadastro-vacina-create',
                path: 'create',
                component: () => import(/* wecadastrockChunkName: 'cadastro-vacina' */ '@/views/cadastro/vacina/Form.vue'),
            },
            {
                name: 'cadastro-vacina-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* wecadastrockChunkName: 'cadastro-vacina' */ '@/views/cadastro/vacina/Form.vue'),
            },
        ],
    },
]